var map = {
	"./2_0_1@2x.png": "C7nK",
	"./2_0_2@2x.png": "2w6U",
	"./2_10@2x.png": "myog",
	"./2_1@2x.png": "4OOF",
	"./2_1_bg@2x.png": "Jflp",
	"./2_2@2x.png": "9lRI",
	"./2_3@2x.png": "8thV",
	"./2_4@2x.png": "lod2",
	"./2_5@2x.png": "jd38",
	"./2_6@2x.png": "fGy9",
	"./2_7@2x.png": "5T21",
	"./2_8@2x.png": "+d9o",
	"./2_9@2x.png": "hXXe",
	"./2_huoma1@2x.png": "IufO",
	"./2_huoma2@2x.png": "6Ds0",
	"./2_platform@2x.png": "7ZWb",
	"./3@2x.png": "DuQb",
	"./4@2x.png": "ZgIR",
	"./5@2x.png": "FMD7",
	"./WeChat_official_account@2x.png": "OlWv",
	"./banner@2x.png": "OxYQ",
	"./email.png": "49XQ",
	"./email_active.png": "C0ao",
	"./foot_bg.png": "vHzm",
	"./local.png": "tI+r",
	"./local_active.png": "RivK",
	"./logo_b@2x.png": "2tBm",
	"./logo_w@2x.png": "SDR3",
	"./phone.png": "VS1g",
	"./phone_active.png": "s4DP",
	"./popup_top_bg@2x.png": "ChOj",
	"./right.png": "feuU",
	"./spirit-1.png": "E2SW",
	"./star.png": "cp1o",
	"./star_active.png": "4H8j",
	"./triangle.png": "lZHA",
	"./uptoTop.png": "l8YB",
	"./wechat.png": "0jFG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LeqP";


//////////////////
// WEBPACK FOOTER
// ./src/img/home ^\.\/.*\.png$
// module id = LeqP
// module chunks = 8